module.exports = __webpack_public_path__ + "img/popup-3_mob.74696318.jpg";